<template>
   <div>
      <FormulaireVisite mode="edit" />
   </div>
</template>

<script>
   import FormulaireVisite from "./FormulaireVisite";

   export default {
      components: {
         FormulaireVisite
      },
      mounted() {
         this.$store.commit("setTitre", "Modifier une visite");
      }
   };
</script>
